import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import CreateEmployee from "@/features/employees/create-employee/crete-employee-modal";
import EmployeesTable from "@/features/employees/employees-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/employees/",
)({
  beforeLoad: ({ context }) => {
    const canReadEmployees = context.ability.can("read", "Employee");

    if (!canReadEmployees) {
      console.error("User does not have permission to read employees");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: () => <EmployeesPage />,
});

function EmployeesPage() {
  const { museumId } = Route.useParams();
  const { locations } = Route.useRouteContext();

  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Personell</Trans>
        </h1>

        <Can I="create" a="Employee">
          <CreateEmployee locations={locations} />
        </Can>
      </Flex>

      <EmployeesTable museumId={museumId} />
    </Box>
  );
}
